export type Course = {
  _id:          string;
  title:        string;
  description:  string;
  modules:      CourseModule[];
  created:      Date|string;
  lastUpdated?: Date|string;
  preTestID?:   any; // Survey
  postTestID?:  any; // Survey
};

export type CourseModule = {
  moduleID:     string;
  moduleNumber: number;
  title:        string;
  pages:        CourseModulePage[];
  endingQuiz:   boolean;
  created:      Date|string;
  lastUpdated?: Date|string;
};

export type CourseModulePage = {
  pageID:       string;
  pageNumber:   number;
  type:         CourseModulePageType;
  title:        string;
  content:      string;
  created:      Date|string;
  lastUpdated?: Date|string;
};

export enum CourseModulePageType {
  Custom     = 'Custom',     // by default
  // ModuleQuiz = 'ModuleQuiz', // optional quiz at the end of module

  // pre-built, readonly pages
  ActivityFlippingCards             = 'ActivityFlippingCards',
  ActivitySimpleQuiz                = 'ActivitySimpleQuiz',
  ActivityBudgetingQuiz             = 'ActivityBudgetingQuiz',
  ActivityDownloadReview            = 'ActivityDownloadReview',
  ActivityEstimatingMonthlyIncome   = 'ActivityEstimatingMonthlyIncome',
  ActivityEstimatingMonthlyExpenses = 'ActivityEstimatingMonthlyExpenses',
  ActivityNeedsVsWants              = 'ActivityNeedsVsWants',
};
